import { put, call, select } from 'redux-saga/effects';
import { browserHistory } from 'react-router';

import {
  DEPENDENT_FORM_STEPS,
  dependentFormActions,
} from '../progress.actions';
import {
  DEPENDENT_FORM,
  DEPENDENT_FORM_DOCUMENTS,
  DEPENDENT_FORM_GENERAL,
  DEPENDENT_FORM_PERSONAL,
  DEPENDENT_FORM_RELATION,
  DEPENDENT_FORM_ROLE,
  DEPENDENT_FORM_COMPLETE,
  DEPENDENT_FORM_EXISTING,
  MESSAGES,
} from '../../../constants/routes';
import {
  DEPENDENT_FORM_SUBMIT_REDIRECT,
  DEPENDENT_ROLES,
} from '../../../constants';
import * as success from '../../ui/success';
import { redirectToUsers } from '../../../utils/appointments/redirect-utils';
import { loggedUserIdSelector } from '../../context/selectors';
import { myProfileRedirectActions } from '../../profiles/my-profile-redirect';
import { selectDependentFormSubmitRedirect } from '../selectors';

export function* redirectToPersonalInfo() {
  yield put(dependentFormActions.setStep(DEPENDENT_FORM_STEPS.PERSONAL));

  browserHistory.push(`${DEPENDENT_FORM}/${DEPENDENT_FORM_PERSONAL}`);
}

export function* redirectToGeneralInfo(id) {
  yield put(dependentFormActions.setStep(DEPENDENT_FORM_STEPS.GENERAL));
  const formatUrl = DEPENDENT_FORM_GENERAL.replace(':id', id);

  browserHistory.push(`${DEPENDENT_FORM}/${formatUrl}`);
}

export function* redirectToDocuments(id) {
  yield put(dependentFormActions.setStep(DEPENDENT_FORM_STEPS.DOCUMENTS));
  const formatUrl = DEPENDENT_FORM_DOCUMENTS.replace(':id', id);

  browserHistory.push(`${DEPENDENT_FORM}/${formatUrl}`);
}

export function* redirectToRelation(id) {
  yield put(dependentFormActions.setStep(DEPENDENT_FORM_STEPS.RELATION));
  const formatUrl = DEPENDENT_FORM_RELATION.replace(':id', id);

  browserHistory.push(`${DEPENDENT_FORM}/${formatUrl}`);
}

export function* redirectToRole() {
  yield put(dependentFormActions.setStep(DEPENDENT_FORM_STEPS.ROLE));
  yield browserHistory.push(`${DEPENDENT_FORM}/${DEPENDENT_FORM_ROLE}`);
}

export function* redirectToCompletePage(assigment) {
  const {
    careRole,
    careUserCreator,
    dependent: { displayableName },
  } = assigment;
  yield put(dependentFormActions.setStep(DEPENDENT_FORM_STEPS.COMPLETE));
  if (careRole === DEPENDENT_ROLES.PARENT) {
    const id = yield select(loggedUserIdSelector);
    const submitRedirect = yield select(selectDependentFormSubmitRedirect);

    const messageId = careUserCreator
      ? 'dependent.form.profileCreated'
      : 'dependent.form.becomeParent';

    if (submitRedirect === DEPENDENT_FORM_SUBMIT_REDIRECT.GET_CARE) {
      redirectToUsers(id, false);
    } else if (submitRedirect === DEPENDENT_FORM_SUBMIT_REDIRECT.PROFILE) {
      yield put(myProfileRedirectActions.goToProfile());
    }

    yield put({
      type: success.consts.UPDATE,
      payload: { id: messageId },
      values: { name: displayableName },
    });
  } else {
    yield browserHistory.push(`${DEPENDENT_FORM}/${DEPENDENT_FORM_COMPLETE}`);
  }
}

export function* redirectToDependentExistPage() {
  yield put(dependentFormActions.setStep(DEPENDENT_FORM_STEPS.USER_EXIST));
  yield browserHistory.push(`${DEPENDENT_FORM}/${DEPENDENT_FORM_EXISTING}`);
}

export function* redirectHistoryBack() {
  yield browserHistory.push(`/${MESSAGES}`);
}

export function* checkAlreadyCreatedUserAndRedirect(assignment) {
  const redirectToMethod =
    assignment.careUserCreator === false
      ? redirectToRelation
      : redirectToGeneralInfo;

  yield call(redirectToMethod, assignment.id);
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/sagas/redirect-saga.js